import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tr-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './panel.component.html',
  //styleUrls: ['./panel.component.scss']
})
export class PanelComponent {

  @Input() header: string;
  @Input() footer: string;

}



// WEBPACK FOOTER //
// ./src/app/shared/components/panel/panel.component.ts